import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetItemsByEventsPlaceDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsByEventsPlaceDossierController.php
* @route '/api/invoicing/{invoice}/wiki-items'
*/
const GetItemsByEventsPlaceDossierController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsByEventsPlaceDossierController.url(args, options),
    method: 'get',
})

GetItemsByEventsPlaceDossierController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/wiki-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetItemsByEventsPlaceDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsByEventsPlaceDossierController.php
* @route '/api/invoicing/{invoice}/wiki-items'
*/
GetItemsByEventsPlaceDossierController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetItemsByEventsPlaceDossierController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetItemsByEventsPlaceDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsByEventsPlaceDossierController.php
* @route '/api/invoicing/{invoice}/wiki-items'
*/
GetItemsByEventsPlaceDossierController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemsByEventsPlaceDossierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetItemsByEventsPlaceDossierController::__invoke
* @see app/Http/Controllers/Invoice/GetItemsByEventsPlaceDossierController.php
* @route '/api/invoicing/{invoice}/wiki-items'
*/
GetItemsByEventsPlaceDossierController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemsByEventsPlaceDossierController.url(args, options),
    method: 'head',
})

export default GetItemsByEventsPlaceDossierController